define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var lpAgentConfig = require('web-agent-config/lpAgentConfig');
    var WebAgentSessionStorage = require('web-agent-utils/WebAgentSessionStorage');
    var TimerManager = require('web-agent-utils/TimerManager');
    var SoundManager = require('web-agent-utils/SoundManager');
    var ResponseQueueManager = require('web-agent-utils/ResponseQueueManager');
    var AgentShortcutsManager = require('web-agent-utils/AgentShortcutsManager');
    var PreDefinedShortcutsManager = require('web-agent-utils/PreDefinedShortcutsManager');
    var EngagementNotificationManager = require('web-agent-utils/EngagementNotificationManager');
    var AgentNotificationManager = require('web-agent-utils/AgentNotificationManager');
    var ViewController = require('web-agent-framework/ViewController');
    var MainViewController = require('web-agent-viewControllers/MainViewController');
    var AccessTokenLogin = require('web-agent-utils/AccessTokenLogin');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpMessagingEngagementsHistoryService = require('web-agent-services/lpMessagingEngagementsHistoryService');
    var lpMessagingEngagementHistoryTableAdapter = require('web-agent-adapters/lpMessagingEngagementHistoryTableAdapter');
    var lpMessagingEngagementHistoryWidgetAdapter = require('web-agent-adapters/lpMessagingEngagementHistoryWidgetAdapter');
    var lpMessagingEngagementHistoryConsumerController = require('web-agent-assets-js/lpMessagingEngagementHistoryConsumerController');
    var lpRingService = require('web-agent-services/lpRingService');
    var QueueOrbAdapter = require('web-agent-adapters/QueueOrbAdapter');
    var lpMessagingAgentsListService = require('web-agent-services/lpMessagingAgentsListService');
    var lpMessagingAgentListAdapter = require('web-agent-adapters/lpMessagingAgentListAdapter');
    var lpMessagingAgentListForTransferService = require('web-agent-services/lpMessagingAgentListForTransferService');
    var lpMessagingAgentListForTransferAdapter = require('web-agent-adapters/lpMessagingAgentListForTransferAdapter');
    var QueueOrbController = require('web-agent-js-controllers/QueueOrbController');
    var AMSConnectionController = require('web-agent-assets-js/lpAMSConnectionController');
    var lpSmileyEmojisController = require('web-agent-assets-js/lpSmileyEmojisController');
    var lpTransferController = require('web-agent-assets-js/lpTransferController');
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var lpAppMediator = require('web-agent-assets-js/lpAppMediator');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var PrivilegeChecker = require('web-agent-utils/PrivilegeChecker');
    var AgentDataManager = require('web-agent-utils/AgentDataManager');
    var AgentGroupDataManager = require('web-agent-utils/AgentGroupDataManager');
    var LPModel = require('web-agent-framework/LPModel');
    var EngagementSimulator = require('web-agent-utils/EngagementSimulator');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var lpAMSSubscriptionsManagerController = require('web-agent-assets-js/lpAMSSubscriptionsManager');
    var lpAMSEngagementsSubscriptionsManager = require('web-agent-assets-js/lpAMSEngagementsSubscriptionsManager');
    var lpConversationsControllerV2 = require('web-agent-assets-js/lpConversationsControllerV2');
    var lpUserProfilesControllerV2 = require('web-agent-assets-js/lpUserProfilesControllerV2');
    var lpMessagesControllerV2 = require('web-agent-assets-js/lpMessagesControllerV2');
    var lpFileSharingController = require('web-agent-assets-js/lpFileSharingController');
    var lpAMSAgentStatusController = require('web-agent-assets-js/lpAMSAgentStatusController');
    var lpVisitorFeedController = require('web-agent-assets-js/lpVisitorFeedControllerBearer');
    var lpAgentController = require('web-agent-assets-js/lpAgentController');
    var lpPublicModelController = require('web-agent-assets-js/lpPublicModelController');
    var lpIframeManager = require('web-agent-assets-js/lpIframeManager');
    var lpAgentListController = require('web-agent-assets-js/lpAgentListController');
    var lpChatController = require('web-agent-assets-js/lpChatController');
    var lpParticipantController = require('web-agent-assets-js/lpParticipantController');
    var lpCannedResponsesController = require('web-agent-assets-js/lpCannedResponsesController');
    var lpEngagementsHistoryTableController = require('web-agent-assets-js/lpEngagementHistoryTableController');
    var lpEngagementsHistoryVisitorController = require('web-agent-assets-js/lpEngagementHistoryVisitorController');
    var lpAMSEngagementHistoryListController = require('web-agent-assets-js/lpAmsEngagementHistoryListController');
    var lpOperatorAndSkillsController = require('web-agent-assets-js/lpOperatorsAndSkillsController');
    var lpVisitorInfoController = require('web-agent-assets-js/lpVisitorInfoController');
    var lpAgentWidgetsController = require('web-agent-assets-js/lpAgentWidgetsController');
    var lpLogicController = require('web-agent-assets-js/lpLogicController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var lpPredictiveDialerController = require('web-agent-assets-js/lpPredictiveDialerController');
    var lpMessagingAgentListController = require('web-agent-assets-js/lpMessagingAgentListController');
    var lpMyConnectionListController = require('web-agent-assets-js/lpMyConnectionListController');
    var lpAppConnectionListController = require('web-agent-assets-js/lpAppConnectionListController');
    var lpCoBrowseController = require('web-agent-assets-js/lpCoBrowseController');
    var lpAudioController = require('web-agent-assets-js/lpAudioController');
    var lpOnlinePresenceController = require('web-agent-assets-js/lpOnlinePresenceController');
    var lpSuggestionsController = require('web-agent-assets-js/lpSuggestionsController');
    var Channels = require('Chronos.Channels');
    var WebAgentDevTools = require('web-agent-assets-js/lpWebAgentDevTools');
    var WidgetsController = require('web-agent-js-controllers/WidgetsController');
    var lpPostSurveyController = require('web-agent-assets-js/lpPostSurveyController');

    var Application = {};

    Application.initApplication = function (data) {
        var localVariables = getLocalVariables(data);
        var applicationModel = createApplicationModel(localVariables);
        setEnvironment(applicationModel, data);
        initialiseSessionByToken();
        createMainView();
        lpUtils.logAccountAndLocaleTimeZone(localVariables.account);
        //TODO phase 1:build screen according to static configuration
        //TODO phase 2:build screen according to dynamic configuration


//////////////  ** Private function start here **  ///////////////////
        function getLocalVariables(data) {
            var account = data.account || '';// || lpTag.storageMethods.getPersistentData("account");
//        var username = lpTag.storageMethods.getPersistentData("username") || '';
//        var password = lpTag.storageMethods.getPersistentData("password") || '';
            var appKey;
            var domain = data.domain;

            if (data.environment) {
                lpAgentConfig.environment = data.environment;
            }

            if (!account && lpAgentConfig.account) {
                account = lpAgentConfig.account;
            }

            if (!lpAgentConfig.accessToken && lpAgentConfig.appKey) {
                appKey = lpAgentConfig.appKey;
            }

            if (!domain && lpAgentConfig.domain) {
                domain = lpAgentConfig.domain;
            }

            var resultData = {};

            // This is done to prevent from the login screen to show when running the webAgent standAlone (not relevant to LiveEngage)
            if (lpAgent.agent.isInResume()) {
                resultData.status = "loggedIn";
            }
            resultData.account = account;
//        resultData.username = username;
//        resultData.password = password;
            resultData.appKey = appKey;
            resultData.domain = domain;
            resultData.connectionState = data.connectionState;

            return resultData;
        }

        function createApplicationModel(localVariables) {
            var privilegeChecker = PrivilegeChecker();

            var model = {
                username: localVariables.username,
                password: localVariables.password,
                account: localVariables.account,
                appKey: localVariables.appKey,
                domain: localVariables.domain,
                accessToken: lpAgentConfig.accessToken,
                agent: {
                    status: localVariables.status,
                    connectionState: localVariables.connectionState,
                    privileges: localVariables.privileges || privilegeChecker.getPrivileges()
                },
                participants: {}
            };
            // In case we need to return the old LPModel
            //return new window.lpTag.LPModel(model, lpTag.WebAgent.WebAgentLogger.getLogger("LPModel"));
            return new LPModel(model, WebAgentLogger.getLogger("LPModel"));
        }

        function setEnvironment(model, data) {
            window.App = window.App || {}; // TODO: should we refactor this into the namespace as well???
            lpTag.WebAgent = lpTag.WebAgent || {};
            lpTag.WebAgent.services = lpTag.WebAgent.services || {};
            lpTag.WebAgent.adapters = lpTag.WebAgent.adapters || {};
            lpTag.WebAgent.controllers = lpTag.WebAgent.controllers || {};
            lpTag.WebAgent.views = lpTag.WebAgent.views || {};

            var App = window.App || {};
            var inResume = lpAgent.agent.isInResume();

            lpTag.WebAgent.logger = WebAgentLogger();
            lpTag.WebAgent.WebAgentSessionStorage = new WebAgentSessionStorage(inResume);

            // internal Pub/Sub channels for the web-agent usage.
            lpTag.WebAgent.channel = new Channels();

            window.App.timerManager = new TimerManager();
            window.App.viewEventsHandler = ViewController.viewEventsHandler;

            lpTag.WebAgent.privileges = lpUtils.cloneObject(require("codeTables/privileges.json"));

            lpTag.WebAgent.agentController = lpAgentController(model);
            lpTag.WebAgent.publicModelController = lpPublicModelController(model);
            lpTag.WebAgent.iFrameManager = lpIframeManager.getInstance();
            lpTag.WebAgent.chatController = lpChatController(model);
            lpTag.WebAgent.participantController = lpParticipantController(model);
            lpTag.WebAgent.logicController = lpLogicController(model, data);
            lpTag.WebAgent.visitorFeedController = lpVisitorFeedController(model);
            lpTag.WebAgent.smileyEmojisController = lpSmileyEmojisController(model);

            lpTag.WebAgent.queueOrbController = QueueOrbController.getInstance({
                model: model,
                adapter: QueueOrbAdapter.getInstance({model: model}),
                respondToNextVisible: !lpTag.WebAgent.logicController.hasMessagingFeature()
            });

            lpTag.WebAgent.soundManager = new SoundManager(lpTag.WebAgent.logicController);
            lpTag.WebAgent.soundManager.init();

            if (lpTag.WebAgent.logicController.useCannedResponsesACService()) {
                lpTag.WebAgent.cannedAnswersController = lpCannedResponsesController(model);
            }

            //skill is a privilege that the 4 roles have
            lpTag.WebAgent.operatorAndSkillsController = lpOperatorAndSkillsController.getInstance({model: model});
            lpTag.WebAgent.operatorAndSkillsController.startPolling();

            if (privilegesController.hasViewHistoryPrivilege()) {
                lpTag.WebAgent.engagementsHistoryTableController = lpEngagementsHistoryTableController(model);
            }
            if (privilegesController.hasViewAgentListPrivilege()) {
                lpTag.WebAgent.agentListController = lpAgentListController(model);
            }

            if (agentLEManager.hasLiveEngage2Feature()) {
                lpTag.WebAgent.engagementsHistoryVisitorController = lpEngagementsHistoryVisitorController(model);
            }

            lpTag.WebAgent.visitorInfoController = new lpVisitorInfoController(model);
            lpTag.WebAgent.engagementSimulator = EngagementSimulator.getInstance(model);

            lpTag.WebAgent.agentWidgetsController = new lpAgentWidgetsController(model);

            if (privilegesController.hasViewMessagingSurveysPrivilege() && lpTag.WebAgent.logicController.hasMessagingSurvey()) {
                lpTag.WebAgent.lpPostSurveyController = lpPostSurveyController.getInstance({model: model});
                lpTag.WebAgent.lpPostSurveyController.startPolling();
            }

            /**
             * Messaging start -->
             */
            if (lpTag.WebAgent.logicController.hasMessagingFeature()) {
                // AMS Connection and Main Controller
                lpTag.WebAgent.amsConnectionController = AMSConnectionController.getInstance({model: model});
                lpTag.WebAgent.amsController = lpAMSController.getInstance({model: model});
                // AMS Sub Components.
                lpTag.WebAgent.amsConversationController = lpConversationsControllerV2.getInstance({model: model});
                lpTag.WebAgent.amsUserProfilesController = lpUserProfilesControllerV2.getInstance({model: model});
                lpTag.WebAgent.amsSubscriptionsController = lpAMSSubscriptionsManagerController.getInstance({model: model});
                lpTag.WebAgent.amsMessagesController = lpMessagesControllerV2.getInstance({model: model});
                lpTag.WebAgent.amsAgentStatusController = lpAMSAgentStatusController.getInstance({model: model});
                lpTag.WebAgent.amsRingService = lpRingService.getInstance({model: model, waitForAssignmentTimeout: lpTag.WebAgent.logicController.getRingTimeoutSettings()});
                lpTag.WebAgent.amsEngagementsSubscriptionsManager = lpAMSEngagementsSubscriptionsManager.getInstance({model: model});
                lpTag.WebAgent.amsFileSharingController = lpFileSharingController.getInstance({model: model});
            var onlinePresenceSiteSetting = lpTag.WebAgent.logicController.getOnlinePresenceSiteSetting();
            if(onlinePresenceSiteSetting.enabled) {
                lpTag.WebAgent.amsOnlinePresenceController = lpOnlinePresenceController.getInstance({model: model, updateInterval: onlinePresenceSiteSetting.updateInterval});
            }

                // List Controllers.
                if (privilegesController.hasViewAllChatsPrivilege() || privilegesController.hasAgentManagerModulePrivilege()) {
                    lpTag.WebAgent.appConnectionListController = new lpAppConnectionListController.getInstance({model: model});
                } else {
                    lpTag.WebAgent.myConnectionListController = lpMyConnectionListController.getInstance({model: model});
                }

                var searchEngagementService = new lpMessagingEngagementsHistoryService();
                lpTag.WebAgent.messagingEngagementHistoryByConsumer = new lpMessagingEngagementHistoryConsumerController.getInstance({
                    model: model,
                    service : new lpMessagingEngagementHistoryWidgetAdapter({
                        service: searchEngagementService
                    })
                });

                if (lpTag.WebAgent.logicController.isMessagingHistoryEnabled()) {
                    var isManager = privilegesController.isManagerRolePrivilege(); // bugfix AE-827 - this privilege should return true only if has manager role, and false to admin that is not manager
                    var hasViewOtherConvPrivilege = privilegesController.hasViewAllChatsPrivilege();
                    var hasAgentViewPrivilege = lpTag.WebAgent.logicController.hasAgentViewPrivilege();

                    if (isManager || hasAgentViewPrivilege) {
                        lpTag.WebAgent.amsEngagementHistoryController = lpAMSEngagementHistoryListController.getInstance({
                            model: model,
                            service: new lpMessagingEngagementHistoryTableAdapter({
                                model: model,
                                service: searchEngagementService
                            }),
                            isManagerViewMode: isManager,
                            hasViewOtherConvPrivilege: hasViewOtherConvPrivilege
                        });
                    }
                }

                if(lpTag.WebAgent.logicController.hasMessagingAgentListEnabled()) {
                    // Check fot feature AC feature and other
                    lpTag.WebAgent.messagingAgentListController = lpMessagingAgentListController.getInstance({
                        model: model,
                        pollingRefreshRate: lpTag.WebAgent.logicController.getPollingRefreshRateFromSiteSettings("le.agent.msgAgentList.refreshRate", 30000),
                        service : new lpMessagingAgentListAdapter({
                            service: new lpMessagingAgentsListService()
                        })
                    });
                }

                if (lpTag.WebAgent.logicController.getAgentMessagingTransferToAgentPermissions()) {
                    lpTag.WebAgent.getMessagingAgentsForTransfer = new lpMessagingAgentListForTransferAdapter({
                        service: new lpMessagingAgentListForTransferService()
                    });
                }
            }
            /**
             * <-- Messaging ends
             */

            window.App.agentController = lpTag.WebAgent.agentController;
            window.App.chatController = lpTag.WebAgent.chatController;
            window.App.participantController = lpTag.WebAgent.participantController;

            window.App.responseQueueManager = new ResponseQueueManager();
            window.App.agentShortcutsManager = new AgentShortcutsManager();
            window.App.preDefinedShourtcutManager = new PreDefinedShortcutsManager();

            window.App.agentGroupDataManager = AgentGroupDataManager.getInstance({model: model});
            window.App.agentDataManager = AgentDataManager.getInstance({model: model});

            lpTag.WebAgent.transferController = new lpTransferController(model);
            lpTag.WebAgent.predictiveDialerController = lpPredictiveDialerController.getInstance({model: model});

            // Secure Forms Feature.
            if (lpTag.WebAgent.logicController.hasSecureFormsFeature() || lpTag.WebAgent.logicController.hasMessagingSecureFormFeature() || lpTag.WebAgent.logicController.hasSecureFormsHistoryViewFeature()) {
                lpTag.WebAgent.secureFormsController = lpSecureFormsController.getInstance({model: model});
            }

            // Audio Messaging Feature
            if (lpTag.WebAgent.logicController.isAudioSharingEnabled()) {
                lpTag.WebAgent.audioController = new lpAudioController({model: model});
            }

            // Core AI Suggestions Feature
            if (agentLEManager.hasAIAssistWidgetFeature()) {
                lpTag.WebAgent.suggestionsController = new lpSuggestionsController({model: model});
            }

            lpTag.WebAgent.AppMediator = lpAppMediator(model);
            lpTag.WebAgent.devTools = new WebAgentDevTools({
                model: model,
                amsConnection: lpTag.WebAgent.amsConnectionController,
                app: App
            });

            lpTag.WebAgent.widgetsController = WidgetsController.getInstance();
        }

        function initialiseSessionByToken() {
            var App = window.App || {};
            if (lpAgentConfig.accessToken || data.accessToken) {
                lpAgent.agent.loadAgentWithToken(data.accessToken);
                var inResume = lpAgent.agent.isInResume();
                window.App.engagementNotificationManager = new EngagementNotificationManager(lpTag.WebAgent.logicController);
                window.App.agentNotificationManager = new AgentNotificationManager(lpTag.WebAgent.logicController);
                setTimeout(function () {
                    new AccessTokenLogin(lpAgentConfig.accessToken || data.accessToken, inResume);
                    if (lpTag.WebAgent.logicController.isAcCoBrowseIntegrationEnabled() ||
                        lpTag.WebAgent.logicController.isAcLiveVideoIntegrationEnabled() ||
                        lpTag.WebAgent.logicController.isAcLiveVoiceIntegrationEnabled()) {

                        lpTag.WebAgent.coBrowseController = new lpCoBrowseController(applicationModel, data);
                    }
                }, 0);
            }
        }

        function createMainView() {
            var view = document.body;
            if (data && data.view) {
                view = data.view;
            }

            // todo - store this somewhere sane!
            window.MainViewControllerBody = view;
            var mainViewController = new MainViewController({
                view: view,
                autoLogin: !!data.accessToken,
                className: "LP_mainwrapping_container",
                modelController: lpTag.WebAgent.AppMediator,
                touchSession: data.keepAliveMethod
            });
            mainViewController.postInitialization();
        }

        function setDevelopmentTools() {

            addConsoleSaveFunctionality();

            function addConsoleSaveFunctionality() {
                window.console.save = function (data, filename) {
                    if (!data) {
                        window.console.error('Console.save: No data');
                        return;
                    }

                    if (!filename) {
                        filename = 'console.json';
                    }

                    if (typeof data === "object") {
                        data = JSON.stringify(data, function (k, v) {
                            if (v === undefined) {
                                return null;
                            }
                            return v;
                        }, 4);
                    }

                    var blob = new Blob([data], {type: 'text/json'}),
                        e = document.createEvent('MouseEvents'),
                        a = document.createElement('a');

                    a.download = filename;
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    a.dispatchEvent(e);
                };
            }
        }
    };

    return Application;

});
